import { ticketsTypes, actionStatuses, usersTypes } from '../../types';

const defaultState = {
  tickets: [],
  isFetchTickets: false,
  errorMessage: '',
  lastPage: 0,
  currentPage: 1,
  threadMeta: {},
  ticketsWithDraft: [],
  threadsWithActiveTimer: [],
  liveThreads: []
};

const map = {
  [`${ticketsTypes.REFETCH_TICKETS}`]: (state, action) => ({
    ...state,
    isFetchTickets: false,
    tickets: action.payload.data.data,
    lastPage: action.payload.data.meta.last_page,
    currentPage: action.payload.data.meta.current_page,
    errorMessage: ''
  }),
  [`${ticketsTypes.GET_TICKETS}${actionStatuses.FULFILLED}`]: (state, action) => ({
    ...state,
    isFetchTickets: false,
    tickets: action.meta.page
      ? [...state.tickets, ...action.payload.data.data]
      : action.payload.data.data,
    lastPage: action.payload.data.meta.last_page,
    currentPage: action.payload.data.meta.current_page,
    errorMessage: ''
  }),
  [`${ticketsTypes.GET_TICKETS}${actionStatuses.PENDING}`]: state => ({
    ...state,
    isFetchTickets: true,
    errorMessage: ''
  }),
  [`${ticketsTypes.GET_TICKETS}${actionStatuses.REJECTED}`]: (state, action) => ({
    ...state,
    isFetchTickets: false,
    errorMessage: action.payload.response.data.message
  }),
  [ticketsTypes.SET_TICKETS_WITH_DRAFT]: (state, action) => ({
    ...state,
    ticketsWithDraft: action.payload
  }),
  [ticketsTypes.SET_THREADS_WITH_ACTIVE_TIMER]: (state, action) => ({
    ...state,
    threadsWithActiveTimer: action.payload
  }),
  [ticketsTypes.SET_LIVE_THREADS]: (state, action) => ({
    ...state,
    liveThreads: action.payload
  }),
  [ticketsTypes.UPDATE_THREAD_META]: (state, action) => ({
    ...state,
    threadMeta: {
      ...state.threadMeta,
      [action.payload.id]: {
        ...state.threadMeta[action.payload.id],
        ...action.payload
      }
    }
  }),
  [ticketsTypes.SET_THREAD_META]: (state, action) => ({
    ...state,
    threadMeta: {
      ...state.threadMeta,
      [action.payload.id]: action.payload
    }
  }),
  [usersTypes.SWITCH_WORKSPACE]: () => defaultState
};

export default (state = defaultState, action) =>
  (map[action.type] && map[action.type](state, action)) || state;
